<template>
  <div class="page-wrapper">
    <b-row class="text-left d-flex">
      <b-col class="mb-3" sm="12" lg="6">
        <!-- Logo + Nome + Versão -->
        <div class="d-flex mb-5">
          <img
            width="50px"
            src="../assets/klaus-a3.svg"
            alt="Logo do Klaus A3"
          />
          <div class="ml-3">
            <span class="titulo">Klaus A3</span>
          </div>
        </div>

        <!-- Descrição do app -->
        <span class="titulo-section">DESCRIÇÃO</span>
        <p class="descricao mt-3">
          Faça o download de documentos fiscais da SEFAZ para sua máquina
          utilizando seu token ou smart card (A3).
        </p>
        <p>
          Com design criado para a melhor experiência do usuário que utiliza
          cartões ou tokens A3, esta ferramenta veio para ser a mais prática do
          mercado.
        </p>

        <h5>Recursos do Klaus A3</h5>
        <ul>
          <li>
            Adicione múltiplos certificados para baixar documentos fiscais da
            SEFAZ
          </li>
          <li>
            Tenha acesso aos XMLs dos documentos fiscais emitidos contra seu
            CNPJ
          </li>
          <li>
            Sincronize automaticamente os documentos para a nuvem Klaus e tenha
            acesso a estes documentos em qualquer lugar
          </li>
          <li>
            Baixe automaticamente os XMLs dos documentos fiscais para seu
            computador
          </li>
          <li>Saiba quais NF-es foram canceladas pelo emitente</li>
          <li>Aplique manifesto (MDF-e) nas NF-es</li>
          <li>
            Saiba quem foi o pagador do frete (tomador) nos CT-es baixados
          </li>
        </ul>

        <!-- Galeria de screenshots 
        <span class="titulo-section">SCREENSHOTS</span>
        <div class="galeria mt-3">
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/klaus-a3-1.jpg')"
              v-pswp="require('../assets/screenshots/klaus-a3-1.jpg')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/klaus-a3-2.jpg')"
              v-pswp="require('../assets/screenshots/klaus-a3-2.jpg')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/klaus-a3-3.jpg')"
              v-pswp="require('../assets/screenshots/klaus-a3-3.jpg')"
            />
          </Photoswipe>
        </div> -->
      </b-col>
    </b-row>
    <!-- Modal de download -->
    <modal-download-suite
      @fechar-modal="fecharModal"
      :visibilidade="isModalVisivel"
    />
  </div>
</template>

<script>
import ModalDownloadSuite from "../components/ModalDownloadSuite.vue";
import mixin from "../mixins/mixin";
import "../assets/theme.css";
export default {
  name: "KlausA3",
  components: {
    ModalDownloadSuite,
  },
  mixins: [mixin],
};
</script>
